import styled from 'styled-components';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

/**
 * maxRows - количество отображаемых строк, если не передано - не обрезаются.
 */
export const Text = styled(Paragraph4)<{ maxRows?: number }>`
    width: 100%;
    color: ${COLORS.TextHint};
    ${p => p.maxRows ? textOverflowLineClamp(p.maxRows) : ''};
`;
